/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:28
 * @LastEditTime: 2019-07-24 14:48:03
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库需求管理接口Url
const websiteIndexTankDemandUrl = '/website/index/storage/tankFarmDemand'

//  普通仓库需求管理接口Url
const websiteTankDemandUrl = '/website/tankFarm/demand'

// 分页查询普通仓库需求列表
export function findPageTankDemand(param, userType) {
  const demandUrl = userType == '' ? websiteIndexTankDemandUrl : websiteTankDemandUrl
  return logistice({
    url: LOGISTICE_GATEWAY + demandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemand'
      }, param))
    }
  })
}
